<template>
  <div id="cards">
    <template v-if="cards.length > 0">
      <carousel :perPage="6" :autoplayTimeout="5000" :loop="true" :paginationEnabled="false" :scrollPerPage="false"
        :autoplay="true">
        <template v-for="(card, i) in cards">
          <slide :key="card.title + i" v-if="true">
            <div @click="typeClick(card)" class="card-item" :style="{ 'width': cardWidth + 'px', 'height': '42vh' }">
              <div style="background-color: rgba(6, 30, 93, 0.5); padding-bottom: 0.1rem;margin-bottom:0.1rem;">
                <div class="card-header">
                  <div :class="[card.lineStatus == 3 ? 'card-header-right' : 'card-header-left']">{{ card.title }}
                  </div>
                  <div :class="'status status-' + card['lineStatus']" v-if="card.lineStatus != 3">
                    <div class="status-text">
                      {{
                        card["lineStatus"] === 0
                          ? "正常生产"
                          : card["lineStatus"] === 1
                            ? "计划停机"
                            : card["lineStatus"] === 2
                              ? "非计划停机"
                              : ""
                      }}
                    </div>
                  </div>
                </div>
                <div v-if="card.lineStatus == 3"
                  style="height:20vh;text-align:center;widht:100%;font-size:0.4rem;font-weight: bold;padding-top:20%;color:#6D6E6F">
                  无生产计划
                </div>
                <dv-charts class="ring-charts"
                  v-if="(card.lineStatus == 0 || card.lineStatus == 1 || card.lineStatus == 2)" :option="card.ring"
                  style="height:20vh;" />
              </div>

              <!--weekCard 挪到这里-->
              <div class="flex" style="overflow:hidden;height:19vh">
                <div class="w-50" style="height:100%;">
                  <dv-charts :option="card.oee" />
                </div>
                <div class="w-50" style="height:100%">
                  <dv-charts :option="card.ftq" />
                </div>
              </div>
            </div>
          </slide>
        </template>
      </carousel>
    </template>
  </div>
</template>

<script>
export default {
  name: "weeklist",
  data() {
    return {
      cards: [],
      datas: this.beans,
      cardWidth: 230,
    };
  },
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.datas = val;
        this.createData();
      },
      deep: true,
    },
  },
  created() {
    const pageWidth = document.documentElement.clientWidth;
    this.cardWidth = (pageWidth / 6) - 15;
  },
  methods: {
    decimal2(num) {
      // 先将数字乘以 10，使用 toFixed 方法将结果保留 0 位小数，再除以 10
      if (num == 0 || num == 100) {
        return num;
      }
      let result = parseFloat((num * 10).toFixed(0)) / 10;
      return result;
    },
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10);
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      }
    },
    typeClick(data) {
      this.$router.push({
        path: "/oee/productLine",
        query: {
          uuid: data.uuid,
          title: data.title,
        },
      });
    },
    createData() {
      const { randomExtend } = this;
      var data = this.datas;
      var opts = [];
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var oeeValue = item["currentOEE"] || 0;
        var ftqValue = item["currentFTQ"] || 0;

        oeeValue = this.decimal2(oeeValue);
        ftqValue = this.decimal2(ftqValue);

        var oeeKpi = item["oeeKpi"];
        var ftqKpi = item["ftqKpi"];
        var lineStatus = item["lineStatus"];
        var statusText = item["lineStatus"] == 1 ? "停线" : "";
        var oeeColor = oeeValue >= oeeKpi ? "#00E690" : "red";
        var ftqColor = ftqValue >= ftqKpi ? "#00E690" : "red";

        if (lineStatus == 3 && i > 5) {
          //未生产，6个后不显示。
          continue;
        }

        var weekList = data[i]["weekList"];
        const xAxis = [];
        const barOee = [];
        const barFtq = [];
        const lineOee = [];
        const lineFtq = [];
        const colors = [];
        const colors2 = [];
        weekList.forEach((val) => {
          xAxis.push(val.week);
          barOee.push(this.decimal2(val.oee));
          barFtq.push(this.decimal2(val.ftq));

          lineOee.push(val.oeeKpi);
          lineFtq.push(val.ftqKpi);

          //颜色组
          colors.push(this.decimal2(val.oee) >= val.oeeKpi ? "#00E690" : "red");
          colors2.push(this.decimal2(val.ftq) >= val.ftqKpi ? "#00E690" : "red");
        });

        var opt = {}; //无生产计划不显示数据
        opt = {
          title: item["line"],
          uuid: item["lineUUID"],
          lineStatus: lineStatus,
          statusText: statusText,
          total: {
            number: [randomExtend(9000, 10000)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#ea6027",
              fontWeight: "bold",
            },
          },
          num: {
            number: [randomExtend(30, 60)],
            content: "{nt}",
            textAlign: "right",
            style: {
              fill: "#00E690",
              fontWeight: "bold",
            },
          },
          ring: {
            grid: {
              top: "70",
            },
            series: [
              {
                type: "gauge",
                dataItemStyle: {
                  fill: "#1ed3e5",
                  fontSize: 13,
                  textAlign: "right",
                },
                data: [
                  {
                    name: "OEE",
                    value: oeeValue,
                    gradient: [oeeColor],
                  },
                  {
                    name: "FTT",
                    value: ftqValue,
                    radius: "53%",
                    valueToFixed: 1,
                    gradient: [ftqColor],
                  },
                ],
                arcLineWidth: 15,
                center: ["50%", "55%"],
                radius: "90%",
                details: {
                  show: true,
                  formatter: "{name}\n{value}%",
                  valueToFixed: 1,
                  position: "start",
                  offset: [10, 5],
                  style: {
                    fontSize: 14,
                    fill: "#FFF",
                    textAlign: "left",
                  },
                },
                pointer: {
                  show: false,
                  valueIndex: 1,
                  style: {
                    scale: [1, 0.8],
                    fill: '#fff'
                  }
                },
                backgroundArc: {
                  show: true,
                  style: {
                    fill: "#0B2140",
                    stroke: "#0B2140",
                  },
                },
                dataItemStyle: {
                  lineCap: "round",
                  lineJoin: "round",
                },
                axisLabel: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
            ],
          },
          oee: {
            grid: {
              right: "15%",
              left: "18%",
              top: "18%",
              bottom: "20%",
            },
            title: {
              text: 'OEE',
              style: {
                fill: "#fff",
                fontSize: 14,
              },
              offset: [0, -12]
            },
            xAxis: {
              name: "WK", // 给X轴加单位
              nameLocation: "end",
              nameGap: 5,
              nameTextStyle: {
                fill: '#fff',
                fontSize: 11,
              },
              data: xAxis,
              axisLabel: {
                style: {
                  fill: "#fff", // 坐标值得具体的颜色
                  fontSize: 11,
                },
              },
              axisLine: {
                show: true,
                style: {
                  stroke: "#fff",
                },
              },
              axisTick: {
                style: {
                  stroke: "#fff", // 坐标值得具体的颜色
                },
              },
            },
            yAxis: {
              name: "%",
              nameGap: 5,
              data: "value",
              nameTextStyle: {
                fill: "#ffffff",
                fontSize: 11,
              },
              label: {
                show: true,
                position: "inside",
                style: {
                  fontSize: 11,
                },
                formatter: (params) => {
                  return params.value + "%";
                },
              },
              axisLine: {
                show: true,
                style: {
                  stroke: "#fff",
                },
              },
              axisTick: {
                show: true,
                style: {
                  stroke: "#fff",
                },
              },
              axisLabel: {
                show: true,
                //  formatter: "{value}%",
                style: {
                  fill: "#fff", // 坐标值得具体的颜色
                  fontSize: 11,
                },
              },
              splitLine: {
                show: true,
                style: {
                  lineDash: [3, 3],
                },
              },
              interval: 50,
              min: 0,
              max: 100,
            },
            series: [
              {
                name: "OEE",
                data: barOee,
                label: {
                  show: true,
                  position: "center",
                  // offset: [0, -10],
                  style: {
                    fill: "#fff",
                    fontSize: 11,
                  },
                  //      formatter: "{value} %",
                },
                type: "bar",
                barGap: "-100%",
                barWidth: 18,
                independentColor: true,
                independentColors: colors,
              }
            ],
          },
          ftq: {
            grid: {
              right: "15%",
              left: "18%",
              top: "18%",
              bottom: "20%",
            },
            title: {
              text: 'FTT',
              style: {
                fill: "#fff",
                fontSize: 14,
              },
              offset: [0, -12]
            },
            xAxis: {
              name: "WK", // 给X轴加单位
              nameLocation: "end",
              nameGap: 5,
              nameTextStyle: {
                fill: '#fff',
                fontSize: 11,
              },
              data: xAxis,
              axisLabel: {
                style: {
                  fill: "#fff", // 坐标值得具体的颜色
                  fontSize: 11,
                },
              },
              axisLine: {
                show: true,
                style: {
                  stroke: "#fff",
                },
              },
              axisTick: {
                style: {
                  stroke: "#fff", // 坐标值得具体的颜色
                },
              },
            },
            yAxis: {
              name: "%",
              nameGap: 5,
              data: "value",
              nameTextStyle: {
                fill: "#ffffff",
                fontSize: 11,
              },
              label: {
                show: true,
                position: "center",
                style: {
                  fontSize: 11,
                },
                formatter: (params) => {
                  return params.value + "%";
                },
              },
              axisLabel: {
                show: true,
                //  formatter: "{value}%",
                style: {
                  fill: "#fff", // 坐标值得具体的颜色
                  fontSize: 11,
                },
              },
              splitLine: {
                show: true,
                style: {
                  lineDash: [3, 3],
                },
              },
              interval: 50,
              min: 0,
              max: 100,
              axisLine: {
                show: true,
                style: {
                  stroke: "#fff",
                },
              },
              axisTick: {
                show: true,
                style: {
                  stroke: "#fff",
                },
              },
            },

            series: [
              {
                name: "FTT",
                data: barFtq,
                label: {
                  show: true,
                  position: "center",
                  // offset: [0, -10],
                  style: {
                    fill: "#fff",
                    fontSize: 11,
                  },
                  //  formatter: "{value} %",
                },
                type: "bar",
                barWidth: 18,
                independentColor: true,
                independentColors: colors2,
              }
            ],
          },
        }
        opts.push(opt);
      }
      this.cards = opts;
    }
  },
  mounted() {
    const { createData } = this;

    createData();

    setInterval(this.createData, 30000);
  },
};
</script>

<style lang="less">
#cards {
  display: block !important;
}

#cards {
  .card-item {
    position: relative;
    margin: 0.1rem .05rem 0.2rem .15rem;
    // margin-right: 20px;
    border-top: 2px solid rgba(1, 153, 209, 0.5);
  }

  .card-header {
    display: flex;
    height: 3vh;
    align-items: center;
    justify-content: space-between;

    .card-header-left {
      position: absolute;
      top: 0.05rem;
      left: 0.05rem;
      //	width: 80%;
      text-align: left;
      font-size: 0.28rem;
      font-weight: bold;
      margin: 0 auto;
      //   padding-right: 1rem;
      text-shadow: 0 0 10px #fff, 0 0 25px #00bfff;
    }

    .card-header-right {
      position: absolute;
      top: 0.05rem;
      left: 0.05rem;
      //	width: 80%;
      text-align: left;
      font-size: 0.28rem;
      font-weight: bold;
      margin: 0 auto;
      color: #6D6E6F;
      text-shadow: 0 0 10px #6D6E6F, 0 0 25px #6D6E6F;
    }
  }

  .status {
    position: absolute;
    top: 0.05rem;
    right: 0.05rem;
    line-height: 0.35rem;
    height: 0.35rem;
    opacity: 0.9;
    filter: alpha(opacity=60);
    -moz-opacity: 0.6;
    display: table-cell;
    vertical-align: middle;
    z-index: 1;
  }

  .status-text {
    text-align: center;
    margin: auto;
    color: #fff;

    width: 1.2rem;
    //	padding: 0 5px 0 5px;
    text-align: center;
    font-weight: bold;
    font-size: 0.24rem;
  }

  .status-1 {
    background: #666666;
  }

  .status-0 {
    background: #00e690;
  }

  .status-2 {
    background: #f44;
  }

  .status-3 {
    background: #666666;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/oee/component/weekcard.vue